export const faqData = [
  // {
  //   category: `Costs and Commissions`,
  //   question: `What are the costs associated with this service?`,
  //   answer: `Regular pricing is based on your patient load. Getting starting is  free, your first 5 patients are complimentary. You can add 5 patients and prescribe unlimited formulas for those patients for free. If you lose a patient, you can delete them from your system (not recommended incase they come back) <br/> Regular pricing breakdown: <br/> 0-5 Patients - FREE <br/> 6-25 Patients - $9.99/mo<br/> 26-50 Patients - $24.99/mo<br/> 50+Patients - $39.99/mo `,
  // },
  {
    category: `Costs and Commissions`,
    question: `How do I get paid commissions?`,
    answer: `Monthly checks are made out to practitioners by the 14th of every month.`,
  },
  {
    category: `Costs and Commissions`,
    question: `Who pays for a prescription?`,
    answer: `You are able to pay for a prescription yourself and have your patient pick it up at your office or you can send it to your patient to review and purchase. Your patient may also pick up their order at our pharmacy.`,
  },
  {
    category: `Costs and Commissions`,
    question: `Who can purchase MHP herbs? / Who can use the service?`,
    answer: `MHP offers services to licensed practitioners of Herbal Medicine. Although patients can buy herbs from our online pharmacy,a prescription by a licensed herbologist is required. We accept the following accreditations: You have a current license and are working in a state that includes Chinese Herbology in your Scope of Practice, or are currently licensed and have obtained the Oriental Medicine or Chinese Herbology certification from the NCCAOM (you are listed with one of these certifications in the NCCAOM's National Registry). Click here to view a 2013 Scope-of-Practice map.You can provide either a diploma that evidences 350 hours of training in Chinese Herbology from an accredited program, or CEU certificates that evidence 350 hours of training in Chinese Herbology.`,
  },
  {
    category: `Compounding Service`,
    question: `Can I buy single herbs from MHP?`,
    answer: `Yes. Our minimum order for granular and raw herbs are 100g. We use our inventory predominantly for customized formulas. We are not established as a single herb retailer or wholesaler.`,
  },
  {
    category: `Compounding Service`,
    question: `Do you stock patent formulas or pre-formulated granulars?`,
    answer: `Yes. Please click on the following link for our list of patent formulas.`,
  },
  {
    category: `Compounding Service`,
    question: `Do you encapsulate formulas?`,
    answer: `Yes. Please make sure to order in quantities of 40g. 40g of granules will make 100 capsules which is also our minimum order. The estimated grams per capsule is .5g +/-.01g.`,
  },
  {
    category: `Compounding Service`,
    question: `Do you decoct raw herbs?`,
    answer: `Yes. Our minimum order is 3 packets of raw herbs.`,
  },
  {
    category: `Compounding Service`,
    question: `Do you grind herbs?`,
    answer: `Yes.  Please click on the link to see services and associated costs. <a target="_blank" href="https://myherbalpharmacy.com/pharmacy"> https://myherbalpharmacy.com/pharmacy</a>`,
  },
  {
    category: `Compounding Service`,
    question: `What services are available?`,
    answer: `We offer decoction, capsule making, grinding and ready to decoct  teabags for raw orders. Please click on the link to see services and associated costs <a target="_blank" href="https://myherbalpharmacy.com/pharmacy"> https://myherbalpharmacy.com/pharmacy</a>`,
  },
  {
    category: `Compounding Service`,
    question: `What bagging and handling methods are available?`,
    answer: `Raw herbs packaged in individual clear and sealed plastic bags. We also offer ready to decoct tea bags for raw orders (.25/bag)Granular herbs are packaged in prescription bottles with attached measuring utensils.Capsules are also packaged in prescription bottles.Decocted herbs are individually packed in plastic for one time use. They can be refrigerated and kept for over 30 days.`,
  },
  {
    category: `Compounding Service`,
    question: `How long does it take to process formulas?`,
    answer: `Decocted herbs will take 24 hours. Granular orders will be ready approximately 30 minutes after submission. Raw orders will be ready approximately 1 hour after submission.`,
  },
  {
    category: `Compounding Service`,
    question: `Can I see the status of my order online?`,
    answer: `Yes. Please click on the "prescriptions" tab on the dashboard or the hamburger menu to view your prescriptions.`,
  },
  {
    category: `Compounding Service`,
    question: `Can I rush a formula?`,
    answer: `Yes. There will be a $5 rush fee associated with this request.`,
  },
  {
    category: `Compounding Service`,
    question: `Is there an after hours pick up location?`,
    answer: `Yes. Your orders can be picked up at 420 Walnut Ave. San Diego 92103 after pharmacy hours until 6pm.`,
  },
  {
    category: `Compounding Service`,
    question: `When can patient pick up orders and where?`,
    answer: `During operating hours at 418 Walnut Ave. San Diego 92103. Operating hours are 9am-5pm. After hours 420 walnut ave between 5-6pm.`,
  },
  {
    category: `Compounding Service`,
    question: `Can I change a formula that has been submitted?`,
    answer: `Possibly. You must call the pharmacy to ensure it has not yet been completed. If it has been completed you will not be able to change your formula. If the formula has not yet been completed, you must cancel your order and submit a new formula. `,
  },
  {
    category: `Quality Assurance`,
    question: `How will I recieve my granular order?`,
    answer: `Your order will be packaged in a plastic sealed bottle with a measuring scoop.`,
  },
  {
    category: `Quality Assurance`,
    question: `How will I receive my herb order?`,
    answer: `Your order will be packaged in food safe, sealed plastic package. Each packet will be sealed separately. Please ask about our ready to soak tea bags.`,
  },
  {
    category: `Quality Assurance`,
    question: `What herbs are available?`,
    answer: `We carry over 300 raw Chinese herbs and over 240 granular Chinese herbs. To find out if we carry a specific herb, please enter the herb name in the formula writing section and our software will indicate if the herb is in stock.`,
  },
  {
    category: `Quality Assurance`,
    question: `How does MHP ensure the quality and safety of their herbs?`,
    answer: `All of our herbs have been directly sourced by our team. We have traveled to China to meet with our suppliers, inspected their farms, inspected their facilities and have secured all the proper documentation to ensure their safety. Please click on on the link below to view herb safety information and documentation.`,
  },
  {
    category: `Quality Assurance`,
    question: `How is my herb order filled?`,
    answer: `Your orders will be filled by highly qualified personnel. Our team consist of individuals that are either herbalists, or students of herbal medicine. Our facilities and equipment ensure cleanliness, accuracy and precision.`,
  },
  {
    category: `Quality Assurance`,
    question: `How does MHP acquire raw herbs that are high quality and pollutant free?`,
    answer: `Your orders will be filled by highly qualified personnel. Our team consist of individuals that are either herbalists, or students of herbal medicine. Our facilities and equipment ensure cleanliness, accuracy and precision.`,
  },
  {
    category: `Quality Assurance`,
    question: `How does MHP produce granules that are high quality and pollutant free?`,
    answer: `Your orders will be filled by highly qualified personnel. Our team consist of individuals that are either herbalists, or students of herbal medicine. Our facilities and equipment ensure cleanliness, accuracy and precision.`,
  },
  {
    category: `Creating a Raw Rx`,
    question: `What is the difference between Raw and Granular?`,
    answer: `Granular herbs are powdered herbs with a 5:1 concentration of Raw herbs. Raw herbs are whole/bulk herbs.`,
  },
  {
    category: `Creating a Raw Rx`,
    question: `How many packets per day should I prescribe?`,
    answer: `Most herbal formulas are based on one packet per day.`,
  },
  {
    category: `Creating a Granular Rx`,
    question: `How do I change the dosages of a granular formula?`,
    answer: `When first adding a granular formulat you will need to enter the "total amount for this formula" filed on the modal that appears. After you have added a formula to the prescription you can change the individual dosages of the herbs and the total dosage for a formula by clicking on the dosage fields.`,
  },
  {
    category: `Creating a Granular Rx`,
    question: `What is the lock button on the bottom of the formula?`,
    answer: `The locking button allows you to lock the total grams you would like to prescribe for that section of your formula. Once locked the software allows you to change the dosages of the individual herbs in the formula while holding the total dosage at your desired amount. Once a formula is locked you can then change the dosage of one herb and the software will change the dosage of the other herbs in the formula according to the integrity of the original ratio.`,
  },
  {
    category: `Creating a Granular Rx`,
    question: `What is the lock button on the bottom of the prescription?`,
    answer: `The lock prescription  button will lock the Entire prescription.`,
  },
  {
    category: `Creating a Granular Rx`,
    question: `Why do the dosages all the herbs change when I adjust the dosage of one ingredient?`,
    answer: `This will only happen when a formula is locked/linked. Once a formula is locked,  the software allows you to change the dosages of the individual herbs in the formula while holding the total dosage at your desired amount. Once a formula is locked you can then change the dosage of one herb and the software will change the dosage of the other herbs in the formula according to the integrity of the original ratio.`,
  },
  {
    category: `Creating a Granular Rx`,
    question: `How can I change the dosage of one herb without it affecting the dosage of the other herbs`,
    answer: `Make sure the formula and the prescription are unlocked. Once unlocked you can change the dosage of any ingredient and it will add or subtract the difference from the total prescribed.`,
  },
  {
    category: `Converting from Raw to Granular`,
    question: `How do I convert from Raw to granular?`,
    answer: `To convert from Raw to Granular, drag the highlighed orange button on top of your screen from Raw to Granular. Once the conversion model appears, you must enter how much (in grams) of the formula you would like so it can convert the formula for you.`,
  },
  {
    category: `Converting from Raw to Granular`,
    question: `Can I change  the total amount of granular herbs I want after I have converted?`,
    answer: `Yes. At anytime during the formula writing process, you can change the total amount at the bottom of the prescription page and the software will do the math for you.`,
  },
  {
    category: `Converting from Raw to Granular`,
    question: `Can I change my formulas dosages after I convert?`,
    answer: `Yes. You can click on the existing dosage field and it will allow you to edit.`,
  },
  {
    category: `Converting from Granular to Raw`,
    question: `Why do you need to know the servings of granular herbs to convert to Raw?`,
    answer: `In order to convert to Raw from Granular you must enter the daily dosage because under the Raw herbs tab you are entering dosages based on Daily values.`,
  },
  {
    category: `Converting from Granular to Raw`,
    question: `How many grams per day is recommended for granular formulas?`,
    answer: `This depends on the formula being prescribed. Most formulas are prescribed at 3scoops 2x/day for a total of 9g per day.`,
  },
  {
    category: `Adding notes`,
    question: `How do I add notes to my prescription?`,
    answer: `At the bottom of the prescription page you will see four tabs titled "instructions", "pharmacy instructions", "patient notes" and "prescription notes". Please choose the appropriate tab and click add note or start writing in the field.`,
  },
  {
    category: `Adding notes`,
    question: `Can my patient see the notes I have added to a prescription?`,
    answer: `Your patient can only see the "patient instructions" notes. `,
  },
  {
    category: `Saving a new formula`,
    question: `How do I save a custom formula for future use?`,
    answer: `Please use the "save as new formula" button on the bottom portion of the prescription page to rename and create a custom formula.`,
  },
  {
    category: `Saving a new formula`,
    question: `Where can I find my custom formulas?`,
    answer: `Your custom formulas can be retrieved during your formula writing process when you click "add formula" and the formula writing modal appears. You will see a tab called "custom formulas", click on the the tab and choose one of your custom formulas to add to the prescription. You can also view and edit your custom formulas by clicking on the "formulas" tab on the dashboard or from the hamburger menu.`,
  },
  {
    category: `Saving a new formula`,
    question: `How do I add a formula to my favorites?`,
    answer: `Under the "formulas" tab from the dashboard you can view your custom formulas, use the start button to pick or unpick a formula as a favorite.`,
  },
  {
    category: `Formulas Tab`,
    question: `Where can I find my custom and favorite formulas`,
    answer: `1. Your favorite formulas can be retrieved during your formula writing process when you click "add formula" and the formula writing modal appears. You will see a tab called "favorite formulas", click on the the tab and choose one of your favorite formulas to add to the prescription.</br>2. you can modify/view your favorite formulas under the "formula tab" on the dashboard or from the hamburger menu.`,
  },
  {
    category: `Prescription Tab`,
    question: `Where can I find my prescription history?`,
    answer: `You can search all of your prescription history by name, date, nickname and status under the "prescription" tab from the dashboard or from the hamburger menu.`,
  },
  {
    category: `Prescription Tab`,
    question: `What is a refill request?`,
    answer: `A refill request is a request made by one of your patients for a refill of a formula. You can review and reorder at anytime.`,
  },
  {
    category: `Prescription Tab`,
    question: `Do I get commissions for refills?`,
    answer: `Yes.`,
  },
  // {
  //   category: `Patient Tab`,
  //   question: `Do I lose my patients information when I make them inactive?`,
  //   answer: ``,
  // },
  {
    category: `Patient Tab`,
    question: `what is the differnece between active and inactive patients?`,
    answer: `Active patietients are patients that you are actively prescribing herbs for. These patients count towards the number of patients you are alowed to use based on your subscription. You can make a patient active or inactive at anytime.`,
  },
  {
    category: `Patient Tab`,
    question: `Where can I find my patient notes?`,
    answer: `Patient notes can be found on under the "patients tab" from the dashboard or form the hamburgher menu. Once you have searched a patient, you can click on the notes image and view your notes history.`,
  },
  {
    category: `Patient Tab`,
    question: `What is the Formula Builder?`,
    answer: `Formula Builder is a feature of MHP developed by a team of experienced herbalists and programmers that guides herbalists in the formula building process. Our software provides diseases, their corresponding patterns, corresponding formulas, formula ingredients, dosages and common modifications. This feature will also convert herb dosages from raw to granular instantaneously as you build your custom formula.`,
  },
  {
    category: `Patient Tab`,
    question: `How do I search a disease and its TCM pattern differentiation?`,
    answer: `Click on "create prescription" tab, add or choose an existing patient. Choose Raw or Granular format and click the "add formula button", on the modal that pops up, use the drop down menus to choose a disease, its correspoindg patterns formulas and modifications.`,
  },
  // {
  //   category: `Patient Tab`,
  //   question: `How do I create custom RX label?`,
  //   answer: ``,
  // },
  {
    category: `Patient Tab`,
    question: `How do I view multiple patient orders in one shopping experience?`,
    answer: `You can view all of your orders under the "prescription" tab.`,
  },
  {
    category: `Patient Tab`,
    question: `Can I refill a prescription for a patient?`,
    answer: `Under the "prescription" tab you can find your order history. In this section you can search and view orders. From the view order tab, you can re-order this formula.`,
  },
  {
    category: `Patient Tab`,
    question: `Can I refill a prescription over the phone or does it have to be done online?`,
    answer: `Yes, but the new order information will not be updated in your account.`,
  },
  {
    category: `Patient Tab`,
    question: `Can I submit formulas over phone or email?`,
    answer: `Yes, you can order by phone and by email, but the new order information will not be updated in your account. You or your patient will have to call to provide shipping and payment information.`,
  },
  {
    category: `Software`,
    question: `Can my clients submit refills directly?`,
    answer: `Not at this time.`,
  },
  // {
  //   category: `Software`,
  //   question: `How do I request a refill?`,
  //   answer: ``,
  // },
  {
    category: `Software`,
    question: `How can I view my order history?`,
    answer: `You can view your orders by clicking on the "orders" tab on the dashboard or on the hamburger menu.`,
  },
  {
    category: `Software`,
    question: `What happens when I accept a share request from a practitioner?`,
    answer: `When you choose to share your information with a practitioner, your practitioner will have access to your profile information not including your c.c information.`,
  },
  {
    category: `Account & Privacy`,
    question: `I forgot my password?`,
    answer: `Please click on the " forgot password/username" link on the registeration page and follow the instructions.`,
  },
  {
    category: `Account & Privacy`,
    question: `Is my account information safe?`,
    answer: `Yes. We have takent some of the highest security measure to ensure safety for your information.The PCI Data Security Standard (PCI DSS) is the highest standard of credit card security. It was established by the Payment Card Industry Security Standards Council, an organization dedicated to preventing credit card theft and identity fraud that was formed by Visa, MasterCard, American Express, and other major credit card companies. The PCI Data Security Standard is a "multifaceted security standard that includes requirements for security management, policies, procedures, network architecture, software design and other critical protective measures." Visit the PCI DSS website to learn more.`,
  },
  {
    category: `Account & Privacy`,
    question: `Is my medical information safe?`,
    answer: `Yes. We are HIPAA compliant.`,
  },
  {
    category: `Account & Privacy`,
    question: `Who can view my medical information?`,
    answer: `Only your practitioner.`,
  },
  {
    category: `Account & Privacy`,
    question: `Who can view my Rx information?`,
    answer: `Only your practitioner.`,
  },
  {
    category: `Shipping & Payments`,
    question: `Can I return my prescription?`,
    answer: `A prescription can be returned if the product is damaged or if the wrong prescription is shipped. Because our formulas are custom made, and for our patients safety, we can not take back any orders.`,
  },
  {
    category: `Shipping & Payments`,
    question: `Where can I pick up my Rx?`,
    answer: `During operating hours at 418 Walnut Ave. San Diego 92103. Operating hours are 9am-5pm. After hours 420 walnut ave between 5-6pm.`,
  },
  // {
  //   category: `Shipping & Payments`,
  //   question: `Can I have Rx shipped?`,
  //   answer: ``,
  // },
  // {
  //   category: `Shipping & Payments`,
  //   question: `Can I pay in store or over the phone?`,
  //   answer: ``,
  // },
  {
    category: `Herbs & Instructions`,
    question: `Are my herbs safe?`,
    answer: `Risk nothing and put your patients first. We use only the highest quality herbs including brands such as San Jiu, Active Herbs, Legendary, Spring Wind, Mei Wei and KPC. All of our sources have been rigorously tested to ensure safety and quality. Our requirements far exceed basic GMP standards including GAP standards, testing for heavy metals, pesticides and bacteria. With frequent trips to China to visit production facilities, our owners are determined to ensure high quality products to our consumers.`,
  },
  {
    category: `Herbs & Instructions`,
    question: `Can i take my herbs on an empty stomach?`,
    answer: `You can take herbs on an empty stomach. If you notice discomfort, consult with your practitioner.`,
  },
  {
    category: `Herbs & Instructions`,
    question: `I am experiencing abdominal pain and bloating after taking my herbs. Is this normal? What should i do?`,
    answer: `Tell your practitioner about your symptoms. Some experience digestive upset during the first few doses of herbs, and then symptoms usually subside.`,
  },
  {
    category: `Herbs & Instructions`,
    question: `I over-cooked my herbal tea and only have one cup? Is it still good?`,
    answer: `Overcooking is not a problem, so long as the tea is not burned. If you have one concentrated cup of herbal tea, add warm filtered water to dilute it.`,
  },
  {
    category: `Herbs & Instructions`,
    question: `What should i do if i forget to drink my tea for one dose?`,
    answer: `If you forget to take a dose, skip that dose. Please do not double up on any doses.`,
  },
  {
    category: `Herbs & Instructions`,
    question: `Are there standard instructions included with the orders?`,
    answer: `No. All instructions must come from your practitioner. If you have any questions please contanct your practitioner.`,
  },
  {
    category: `Security & Privacy`,
    question: `How secure is my credit card information?`,
    answer: `MHP takes the security of your credit card information very seriously. Of course, all credit card data is communicated over a secure, encrypted connection using SSL. But unlike many online businesses, we don't stop there. We use Extended Validation SSL, and we adhere to the highest standard of credit card security: the PCI Data Security Standard.`,
  },
  {
    category: `Security & Privacy`,
    question: `What is the PCI Data Security Standard?`,
    answer: `The PCI Data Security Standard (PCI DSS) is the highest standard of credit card security. It was established by the Payment Card Industry Security Standards Council, an organization dedicated to preventing credit card theft and identity fraud that was formed by Visa, MasterCard, American Express, and other major credit card companies. The PCI Data Security Standard is a "multifaceted security standard that includes requirements for security management, policies, procedures, network architecture, software design and other critical protective measures." Visit the PCI DSS website to learn more.`,
  },
  {
    category: `Security & Privacy`,
    question: `What is an Extended Validation SSL certificate, and what does the green bar in my browser mean?`,
    answer: `Extended Validation (EV) SSL certificates offer an extra level of protection above normal SSL encryption. Developed to combat the problem of fraudulent websites and "phishing", EV certificates are issued by certificate authorities like GeoTrust only after they have verified the identity and legitimacy of the company. Most banks and major e-commerce sites now use EV certificates exclusively. In modern browsers, a green bar appears with the company name whenever you are viewing a website with an EV certificate. Look for the green bar to be sure you are on a legitimate, validated website.`,
  },
  {
    category: `Security & Privacy`,
    question: `Is patient health information kept confidential?`,
    answer: `Patient health information is kept strictly confidential at MHP. Prescription details are discussed with no one but the patient and the health practitioner who submitted the prescription. MHP's policies and procedures are fully compliant with all relevant federal and state regulations, including the HIPAA Privacy Rule.`,
  },
  {
    category: `Security & Privacy`,
    question: `What is HIPAA and the HIPAA Privacy Rule?`,
    answer: `The HIPAA Privacy Rule is the primary federal law governing the security and privacy of your health information. It is part of the Health Insurance Portability and Accountability Act of 1996 (HIPAA), which is enforced by the U.S. Department of Health & Human Services. The HHS website has extensive information about the HIPAA Privacy Rule and related regulations.`,
  },
  {
    category: `Payments, Shipping & Returns`,
    question: `What are the payment options?`,
    answer: `Credit card.`,
  },
  {
    category: `Payments, Shipping & Returns`,
    question: `Can uncooked formulas be returned?`,
    answer: `Unfortunately we can not restock formulas hence we can not accept formula returns.`,
  },
  {
    category: `Payments, Shipping & Returns`,
    question: `What is the return policy?`,
    answer: `100% guarantee on the quality, safety and accuracy of our herbs. Unfortunately we do not accept any returns outside the parameters of Quality, Safety or Accuracy.`,
  },
  {
    category: `Other`,
    question: `Is there a difference between student and professional accounts?`,
    answer: `Yes. Student accounts are not able to invite patients.`,
  },
  {
    category: `Other`,
    question: `How do I order stock for my office?`,
    answer: `Please contact Ramtin Dehkhoda to discuss stocking and pricing options.`,
  },
  {
    category: `Other`,
    question: `Do you offer bulk discounts?`,
    answer: `Yes. Please contact Ramtin Dehkhoda to discuss stocking and pricing options.`,
  },
  {
    category: `Safety`,
    question: `How can I safely prescribe for patients with allergies?`,
    answer: `Please view the allergy list using this link.`,
  },
  {
    category: `Safety`,
    question: `How does MHP ensure safe herb dosage?`,
    answer: `All of our dosage information are suggestions. It is the responsibility of the practitioners to research and provide dosages.`,
  },
  {
    category: `Safety`,
    question: `How much formulas does one of your spoons/scoops hold?`,
    answer: `Granular scoops are 1.5g.`,
  },
  {
    category: `Safety`,
    question: `How much formulas does one capsule hold?`,
    answer: `Approximately .5g.`,
  },
  // {
  //   category: `Safety`,
  //   question: `What is the shelf life of granular and raw herbs.`,
  //   answer: ``,
  // },
];
